<template>
  <h3>Шаг 9. Документы</h3>
  <p>
    Проверьте информацию в карточке проекта и, если согласны, согласуйте проект.
  </p>
  <div>
    <a-form class="form administrator-project-form" layout="vertical">
      <administrator-project-form-row
        :show-available="false"
        :offset-available="false"
      >
        <attachments-input
          :init-attachments="model.attachments"
          :is-editable="false"
          @update="null"
        />
      </administrator-project-form-row>
    </a-form>
  </div>
</template>

<script setup>
  import { onMounted, reactive, watch } from 'vue';
  import AdministratorProjectFormRow from '../AdministratorProjectFormRow.vue';
  import AttachmentsInput from '@/components/attachments/AttachmentsInput.vue';

  const model = reactive({
    attachments: [],
  });

  const props = defineProps({
    project: {
      type: Object,
      require: true,
    },
  });

  onMounted(() => {
    props.project && fillModel();
  });

  watch(
    () => props.project,
    () => {
      fillModel();
    }
  );

  const fillModel = () => {
    try {
      model.attachments = props.project.attachments;
    } catch (error) {
      console.error('error', error);
    }
  };
</script>

<style lang="scss" scoped>
  @use "@/assets/styles/_colors.scss" as *;

  .attachments {
    display: flex;
    flex-direction: row;
    background-color: $color-bg-secondary-grey;
    border-radius: 7px;
    gap: 44px;
    flex-wrap: wrap;
    padding: 24px;
    margin-top: 20px;
  }

  .ant-upload-text {
    color: #aeb4dd;
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    width: 194px;
  }
</style>
